import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { HttpService } from './http.service';
import { ErrorReportService } from './error-report.service';


@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  currentUser:any;

  constructor(
    private snackBar: MatSnackBar,
    private router: Router,
    private http: HttpService,
    private errorReport: ErrorReportService,
  ) { }

  showAccountActivationMessage(): void {

    this.currentUser = JSON.parse(localStorage.getItem('token'));
    
      const data = {
        companyId: this.currentUser.company_id
      }
      this.http.list('company:getAdmin', data)
        .subscribe(
          (result:any) => {
            const adminUser = result.data.companyemail;
            const fullname = result.data.firstname+' '+result.data.lastname;

            if(this.currentUser.email == adminUser){

              this.snackBar.open(
                'Por favor, Ative sua Conta para continuar usando a plataforma',
                'Fechar',
                {
                  duration: 2000,
                  panelClass: ['warning-snackbar'],
                  horizontalPosition: 'center',
                  verticalPosition: 'top',
                });
          
              setTimeout(() => {
                this.router.navigate(['/recruiter/finance']);
              }, 3000);

            }else{
              
              this.snackBar.open(
                'Ative sua conta pela conta principal. Por favor, contate o administrador '+fullname+' usando o E-mail: '+adminUser,
                'Fechar',
                {
                  duration: 10000,
                  panelClass: ['warning-snackbar'],
                  horizontalPosition: 'center',
                  verticalPosition: 'top',
                });
          
            }

          },
          err => this.errorReport.showMessage(err)
        )

  }

}
